// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tip-component {
  color: var(--color-black);
  padding: 0px;
  border-radius: 0px;
}

.title-row {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.title-row .title {
  max-width: 37%;
  position: relative;
  font-family: Title;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.title-row .title::before, .title-row .title::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 50px;
  height: 2px;
  background: var(--color-black);
}
.title-row .title::before {
  transform: translate(-100%, 0px);
  left: 0%;
}
.title-row .title::after {
  transform: translate(100%, 0px);
  right: 0%;
}

.tip-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.title {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: var(--color-black);
  margin-right: 10px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
}

.chip {
  width: -moz-fit-content;
  width: fit-content;
  padding: 5px 20px;
  text-align: start;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
  border-radius: 16px;
}

.tip-img {
  height: 30px;
  width: 32px;
}

.tip {
  position: relative;
  height: 60px;
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 1px solid #000000;
  border-radius: 100px;
  color: #fff;
  font-family: AppFontBold, sans-serif;
}
.tip .sum {
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 18.72px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
}
.tip:last-of-type {
  margin-right: 0;
}
.tip .selected-checkmark {
  display: none;
}
.tip.selected {
  background: var(--ion-color-primary);
}
.tip.selected .selected-checkmark {
  display: block;
  position: absolute;
  top: 1px;
  right: 37px;
  height: 20px;
  width: 20px;
}

.custom-tip-row {
  justify-content: space-between;
}
.custom-tip-row ion-icon {
  cursor: pointer;
}

.custom {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}

.titles-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.titles-wrapper p {
  margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tip/tip.component.scss"],"names":[],"mappings":"AAAA;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;AACD;;AAEA;EACC,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACD;AACC;EACC,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AACF;AACE;EAEC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;AAAH;AAGE;EACC,gCAAA;EAEA,QAAA;AAFH;AAIE;EACC,+BAAA;EACA,SAAA;AAFH;;AAOA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAJD;;AAOA;EACC,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AAJD;;AAOA;EACC,uBAAA;EAAA,kBAAA;EACA,iBAAA;EAEA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AALD;;AAQA;EACC,YAAA;EACA,WAAA;AALD;;AAQA;EACC,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,uBAAA;EACA,yBAAA;EACA,oBAAA;EACA,WAAA;EACA,oCAAA;AAND;AAQC;EACC,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AANF;AASC;EACC,eAAA;AAPF;AASC;EACC,aAAA;AAPF;AAUC;EACC,oCAAA;AARF;AAUE;EACC,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EAEA,YAAA;EACA,WAAA;AATH;;AAcA;EACC,8BAAA;AAXD;AAaC;EACC,eAAA;AAXF;;AAcA;EACC,aAAA;EACA,yBAAA;EACA,eAAA;AAXD;;AAcA;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;AAXD;AAYC;EACC,iBAAA;AAVF","sourcesContent":[".tip-component {\n\tcolor: var(--color-black);\n\tpadding: 0px;\n\tborder-radius: 0px;\n}\n\n.title-row {\n\tposition: relative;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t.title {\n\t\tmax-width: 37%;\n\t\tposition: relative;\n\t\tfont-family: Title;\n\t\tfont-size: 24px;\n\t\tline-height: 120%;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\ttext-transform: uppercase;\n\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\twidth: 50px;\n\t\t\theight: 2px;\n\t\t\tbackground: var(--color-black);\n\t\t}\n\n\t\t&::before {\n\t\t\ttransform: translate(-100%, 0px);\n\n\t\t\tleft: 0%;\n\t\t}\n\t\t&::after {\n\t\t\ttransform: translate(100%, 0px);\n\t\t\tright: 0%;\n\t\t}\n\t}\n}\n\n.tip-row {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n}\n\n.title {\n\tfont-family: AppFontSemiBold, sans-serif;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\tcolor: var(--color-black);\n\tmargin-right: 10px;\n\ttext-transform: uppercase;\n\twidth: 100%;\n\ttext-align: center;\n}\n\n.chip {\n\twidth: fit-content;\n\tpadding: 5px 20px;\n\n\ttext-align: start;\n\tfont-size: 10px;\n\tline-height: 12px;\n\tletter-spacing: 0em;\n\ttext-align: left;\n\ttext-transform: uppercase;\n\tborder-radius: 16px;\n}\n\n.tip-img {\n\theight: 30px;\n\twidth: 32px;\n}\n\n.tip {\n\tposition: relative;\n\theight: 60px;\n\tmargin-right: 5px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\n\tbackground: transparent;\n\tborder: 1px solid #000000;\n\tborder-radius: 100px;\n\tcolor: #fff;\n\tfont-family: AppFontBold, sans-serif;\n\n\t.sum {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 12px;\n\t\tline-height: 18.72px;\n\t\tletter-spacing: 0%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t}\n\n\t&:last-of-type {\n\t\tmargin-right: 0;\n\t}\n\t.selected-checkmark {\n\t\tdisplay: none;\n\t}\n\n\t&.selected {\n\t\tbackground: var(--ion-color-primary);\n\n\t\t.selected-checkmark {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tright: 37px;\n\n\t\t\theight: 20px;\n\t\t\twidth: 20px;\n\t\t}\n\t}\n}\n\n.custom-tip-row {\n\tjustify-content: space-between;\n\n\tion-icon {\n\t\tcursor: pointer;\n\t}\n}\n.custom {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tcursor: pointer;\n}\n\n.titles-wrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tp {\n\t\tmargin-left: 15px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
